import { render, staticRenderFns } from "./NewSubjectSpecializations.vue?vue&type=template&id=3aa9cf5c&"
import script from "./NewSubjectSpecializations.vue?vue&type=script&lang=js&"
export * from "./NewSubjectSpecializations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports